"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnitConstant = exports.SkuStocktakeModeConstant = exports.SkuBarcodeFormatConstant = exports.PackageClosure = exports.CountryConstant = exports.Constant = exports.CategoryConstant = void 0;

var _lodash = require("lodash");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Constant = /*#__PURE__*/function () {
  function Constant(keys) {
    var _this = this;

    _classCallCheck(this, Constant);

    (0, _lodash.each)(keys, function (val, key) {
      return _this[key] = val;
    });
  }

  _createClass(Constant, [{
    key: "toArray",
    value: function toArray() {
      return (0, _lodash.map)(this);
    }
  }]);

  return Constant;
}();

exports.Constant = Constant;

var UnitConstant = /*#__PURE__*/function (_Constant) {
  _inherits(UnitConstant, _Constant);

  var _super = _createSuper(UnitConstant);

  function UnitConstant() {
    _classCallCheck(this, UnitConstant);

    return _super.apply(this, arguments);
  }

  _createClass(UnitConstant, [{
    key: "get",
    value: function get(id) {
      return (0, _lodash.find)(this, {
        id: id
      }) || null;
    }
  }, {
    key: "defaultTypeUnit",
    value: function defaultTypeUnit(type) {
      return (0, _lodash.find)(this, function (unit) {
        return unit.type === type && unit.baseTypeUnit;
      });
    }
  }, {
    key: "listTypeUnits",
    value: function listTypeUnits(type) {
      return (0, _lodash.pickBy)(this, function (unit
      /*, key*/
      ) {
        return !type || unit.type === type;
      });
    }
  }, {
    key: "listTypeUnitsIds",
    value: function listTypeUnitsIds(types) {
      var _this2 = this;

      if (Array.isArray(types)) {
        return (0, _lodash.flatten)(types.map(function (type) {
          return (0, _lodash.map)(_this2.listTypeUnits(type), 'id');
        }));
      } else {
        return (0, _lodash.map)(this.listTypeUnits(types), 'id');
      }
    }
  }, {
    key: "typeNormalizedAmount",
    value: function typeNormalizedAmount(amount, unit) {
      return amount * unit.typeMultiplier;
    }
  }, {
    key: "typeGroupNormalizedAmount",
    value: function typeGroupNormalizedAmount(amount, unit) {
      return amount * unit.typeGroupMultiplier;
    }
  }, {
    key: "isUnitType",
    value: function isUnitType(unit, unitType) {
      return unit.type === unitType;
    }
  }, {
    key: "getUnitType",
    value: function getUnitType(id) {
      var unit = (0, _lodash.find)(this, {
        id: id
      }) || null;
      return (0, _lodash.get)(unit, 'type', null);
    }
  }]);

  return UnitConstant;
}(Constant);

exports.UnitConstant = UnitConstant;

var CategoryConstant = /*#__PURE__*/function (_Constant2) {
  _inherits(CategoryConstant, _Constant2);

  var _super2 = _createSuper(CategoryConstant);

  function CategoryConstant() {
    _classCallCheck(this, CategoryConstant);

    return _super2.apply(this, arguments);
  }

  _createClass(CategoryConstant, [{
    key: "listCategories",
    value: function listCategories() {
      return (0, _lodash.pickBy)(this, function
        /*category*/
      () {
        return true;
      });
    }
  }, {
    key: "listCategoriesIds",
    value: function listCategoriesIds() {
      return (0, _lodash.map)(this.listCategories(), function (category) {
        return category.id;
      });
    }
  }]);

  return CategoryConstant;
}(Constant);

exports.CategoryConstant = CategoryConstant;

var SkuStocktakeModeConstant = /*#__PURE__*/function (_Constant3) {
  _inherits(SkuStocktakeModeConstant, _Constant3);

  var _super3 = _createSuper(SkuStocktakeModeConstant);

  function SkuStocktakeModeConstant() {
    _classCallCheck(this, SkuStocktakeModeConstant);

    return _super3.apply(this, arguments);
  }

  _createClass(SkuStocktakeModeConstant, [{
    key: "getDefault",
    value: function getDefault() {
      return this.QUANTITY;
    }
  }]);

  return SkuStocktakeModeConstant;
}(Constant);

exports.SkuStocktakeModeConstant = SkuStocktakeModeConstant;

var CountryConstant = /*#__PURE__*/function (_Constant4) {
  _inherits(CountryConstant, _Constant4);

  var _super4 = _createSuper(CountryConstant);

  function CountryConstant() {
    _classCallCheck(this, CountryConstant);

    return _super4.apply(this, arguments);
  }

  _createClass(CountryConstant, [{
    key: "toArraySuggested",
    value: function toArraySuggested(alpha2Code) {
      var _this3 = this;

      return (0, _lodash.map)(this.getSuggested(alpha2Code), function (code) {
        return _this3[code];
      });
    }
  }, {
    key: "toArrayOthers",
    value: function toArrayOthers(alpha2Code) {
      var _this4 = this;

      return (0, _lodash.filter)(this.toArray(), function (country) {
        return _this4.getSuggested(alpha2Code).indexOf(country.alpha2Code) < 0;
      });
    }
  }, {
    key: "findByCallingCode",
    value: function findByCallingCode(callingCode) {
      return (0, _lodash.find)(this, function (country) {
        return (0, _lodash.get)(country, 'callingCodes', []).indexOf(callingCode.toString()) >= 0;
      });
    }
  }, {
    key: "getSuggested",
    value: function getSuggested(alpha2Code) {
      var suggested = ['PL', 'GB', 'US', 'AU'];
      var countryCode = alpha2Code && alpha2Code.toUpperCase() == 'EN' ? 'GB' : alpha2Code;

      if (countryCode) {
        var index = suggested.indexOf(countryCode);

        if (index > -1) {
          suggested.splice(index, 1);
        }

        suggested.unshift(countryCode);
      }

      return suggested;
    }
  }]);

  return CountryConstant;
}(Constant);

exports.CountryConstant = CountryConstant;

var SkuBarcodeFormatConstant = /*#__PURE__*/function (_Constant5) {
  _inherits(SkuBarcodeFormatConstant, _Constant5);

  var _super5 = _createSuper(SkuBarcodeFormatConstant);

  function SkuBarcodeFormatConstant() {
    _classCallCheck(this, SkuBarcodeFormatConstant);

    return _super5.apply(this, arguments);
  }

  _createClass(SkuBarcodeFormatConstant, [{
    key: "guessBarcodeFormat",
    value: function guessBarcodeFormat(barcode) {
      var barcodeSchema = (0, _lodash.find)((0, _lodash.orderBy)(this.toArray(), 'priority'), function (schema) {
        return schema.regex.test(barcode);
      });
      return (0, _lodash.get)(barcodeSchema, 'name', null);
    }
  }]);

  return SkuBarcodeFormatConstant;
}(Constant);

exports.SkuBarcodeFormatConstant = SkuBarcodeFormatConstant;

var PackageClosure = /*#__PURE__*/_createClass(function PackageClosure(_ref) {
  var name = _ref.name,
      closed = _ref.closed,
      id = _ref.id,
      weight = _ref.weight,
      weightUnitId = _ref.weightUnitId;

  _classCallCheck(this, PackageClosure);

  _defineProperty(this, "name", null);

  _defineProperty(this, "closed", false);

  _defineProperty(this, "id", null);

  _defineProperty(this, "weight", null);

  _defineProperty(this, "weightUnitId", null);

  this.name = name;
  this.closed = closed;
  this.id = id;
  this.weight = weight;
  this.weightUnitId = weightUnitId;
});

exports.PackageClosure = PackageClosure;

_defineProperty(PackageClosure, "DEFAULT", new PackageClosure({
  name: 'default',
  closed: true,
  id: null,
  weight: null,
  weightUnitId: null
}));

_defineProperty(PackageClosure, "NONE", new PackageClosure({
  name: 'none',
  closed: false,
  id: null,
  weight: null,
  weightUnitId: null
}));